import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Hero from "../components/Hero";
import SectionTitle from "../components/SectionTitle";
import ProductCard from "../components/ProductCard";

const Home = () => {

  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
  try {

    const [featuredRes, newRes, bestRes] = await Promise.all([
      axios.get("/api/products?featured=true&limit=8"),
      axios.get("/api/products?sort=newest&limit=8"),
      axios.get("/api/products?sort=best-selling&limit=8"),
    ]);

    setFeaturedProducts(
      Array.isArray(featuredRes?.data?.products)
        ? featuredRes.data.products
        : []
    );

    setNewArrivals(
      Array.isArray(newRes?.data?.products)
        ? newRes.data.products
        : []
    );

    setBestSellers(
      Array.isArray(bestRes?.data?.products)
        ? bestRes.data.products
        : []
    );

  } catch (error) {
    console.log(error);

    setFeaturedProducts([]);
    setNewArrivals([]);
    setBestSellers([]);
  }
};

 const collections = [
  {
    title: "Bridal Lehenga",
    image:
      "https://images.unsplash.com/photo-1610186594416-2a6c2a63f65c?q=80&w=1400&auto=format&fit=crop",
    link: "/shop?category=bridal-lehenga",
  },
  {
    title: "Designer Sarees",
    image:
      "https://images.unsplash.com/photo-1610030469983-98e550d6193c?q=80&w=1400&auto=format&fit=crop",
    link: "/shop?category=designer-sarees",
  },
  {
    title: "Wedding Gowns",
    image:
      "https://images.unsplash.com/photo-1594552072238-b8a33785b261?q=80&w=1400&auto=format&fit=crop",
    link: "/shop?category=wedding-gowns",
  },
  {
    title: "Party Wear",
    image:
      "https://images.unsplash.com/photo-1595777457195-9f8d800c9255?q=80&w=1400&auto=format&fit=crop",
    link: "/shop?category=party-wear",
  },
];

  return (
    <div className="bg-white dark:bg-black">

      <Hero />

      {/* Featured Banner */}

      <section className="py-20 px-6">

        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">

          {[
            "https://images.unsplash.com/photo-1583391733956-6c77a5faeec5",
            "https://images.unsplash.com/photo-1610186594416-2a6c2a63f65c",
            "https://images.unsplash.com/photo-1593030761757-71fae45fa0e7"
          ].map((img, index) => (

            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              className="relative rounded-3xl overflow-hidden shadow-2xl"
            >

              <img
                src={img}
                className="h-[450px] w-full object-cover"
              />

              <div className="absolute inset-0 bg-black/40"/>

              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-2xl font-bold">
                  Luxury Bridal
                </h3>

                <Link to="/shop" className="underline">
                  Shop Now →
                </Link>

              </div>

            </motion.div>

          ))}

        </div>

      </section>

      {/* Luxury Collections */}

      <section className="py-28 px-6 bg-gradient-to-b from-white to-gray-100 dark:from-black dark:to-gray-900">

        <div className="max-w-7xl mx-auto">

          <SectionTitle
            title="Luxury Collections"
            subtitle="Handcrafted bridal masterpieces"
          />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mt-20">

            {collections.map((collection, index) => (

              <motion.div
                key={collection.title}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                className="relative group overflow-hidden rounded-3xl shadow-2xl"
              >

                <Link to={collection.link}>

                  <img
                    src={collection.image}
                    alt={collection.title}
                    className="w-full h-[420px] object-cover group-hover:scale-110 transition duration-700"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"/>

                  <div className="absolute bottom-8 left-8 text-white">

                    <h3 className="text-3xl font-bold mb-3">
                      {collection.title}
                    </h3>

                    <span className="border border-white px-6 py-2 rounded-full text-sm">
                      Explore →
                    </span>

                  </div>

                </Link>

              </motion.div>

            ))}

          </div>

        </div>

      </section>

      {/* New Arrivals */}

      <section className="py-28 px-6">

        <div className="max-w-7xl mx-auto">

          <SectionTitle
            title="New Arrivals"
            subtitle="Latest bridal couture"
          />

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 mt-20">

            {Array.isArray(newArrivals) && newArrivals.map((product) => (
  <ProductCard key={product._id} product={product}/>
))}

          </div>

        </div>

      </section>

      {/* Wedding Gallery */}

      <section className="py-28 px-6 bg-gray-100 dark:bg-gray-900">

        <div className="max-w-7xl mx-auto">

          <SectionTitle
            title="Wedding Inspiration"
            subtitle="Real bridal moments"
          />

          <div className="grid md:grid-cols-4 gap-6 mt-16">

            <img src="https://images.unsplash.com/photo-1529634893523-247fb9c4e3c8" className="rounded-2xl h-[320px] object-cover w-full"/>

            <img src="https://images.unsplash.com/photo-1610186594416-2a6c2a63f65c" className="rounded-2xl h-[320px] object-cover w-full"/>

            <img src="https://images.unsplash.com/photo-1593030761757-71fae45fa0e7" className="rounded-2xl h-[320px] object-cover w-full"/>

            <img src="https://images.unsplash.com/photo-1583391733956-6c77a5faeec5" className="rounded-2xl h-[320px] object-cover w-full"/>

          </div>

        </div>

      </section>

      {/* Brand Story */}

      <section className="py-32 bg-black text-white">

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center px-6">

          <motion.img
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            src="https://images.unsplash.com/photo-1593030761757-71fae45fa0e7"
            className="rounded-3xl shadow-2xl"
          />

          <motion.div>

            <h2 className="text-5xl font-bold mb-6">
              Crafted for Brides
            </h2>

            <p className="text-lg opacity-80">

              Our bridal collections celebrate timeless elegance and
              exquisite craftsmanship.

            </p>

            <Link
              to="/shop"
              className="inline-block mt-8 border border-white px-8 py-3 rounded-full"
            >
              Discover Collection
            </Link>

          </motion.div>

        </div>

      </section>

      {/* Best Sellers */}

      <section className="py-28 px-6">

        <div className="max-w-7xl mx-auto">

          <SectionTitle
            title="Best Sellers"
            subtitle="Most loved by brides"
          />

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 mt-20">

            {Array.isArray(bestSellers) && bestSellers.map((product) => (
              <ProductCard key={product._id} product={product}/>
            ))}

          </div>

        </div>

      </section>

    </div>
  );
};

export default Home;